export const phoneRegExp = /^$|^(\([0-9]{3}\)|[0-9]{3}-?)[0-9]{3}-?[0-9]{4}$/;

export const digitRegexp = '(?=.*?[0-9])';
export const upperCaseRegexp = '(?=.*?[A-Z])';
export const lowerCaseRegexp = '(?=.*?[a-z])';
export const specialCharacterRegexp = '(?=.*?[#?!@$%^&*-])';
